import { Col, Modal, Row } from "antd-v5";
import { t } from "i18next";
import React from "react";
import EtTag from "../../../eqComponents/eqCustom/EtTag/EtTag";
import { IUnpaidOrdersDto, UnpaidOrdersType } from "../../shared/general/IUnpaidOrders";
import EqButton from "../../custom/eqButton/EqButton";
import { useTranslation } from "react-i18next";
import { EqIconCalendar, EqIconPrice } from "../../custom/eqIcon/EqIcons";
import moment from "moment";
import { ticksToMilliSeconds } from "../../shared/Common";
import "./EqUnpaidOrdersTrainer.scss";
interface UnpaidOrdersModalTrainerProps {
    isModalVisible: boolean;
    handleCancel: () => void;
    unpaidOrders?: IUnpaidOrdersDto[];
    handleShowMessageModal: (email: string) => void;
    showReminderModal: (email: string) => void;
}

const UnpaidOrdersModalTrainer: React.FC<UnpaidOrdersModalTrainerProps> = ({
    isModalVisible,
    handleCancel,
    unpaidOrders,
    handleShowMessageModal,
    showReminderModal,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            width={1000}
            title={t("unPaidOrders") as React.ReactNode}
            className="unpaid-Orders-modal-trainer"
            open={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            maskClosable={true}
        >
            {unpaidOrders?.map((item, index) => (
                <div className="eq-activity-row" key={index}>
                    <Row className="eq-status-row-border">
                        <Col className="content-col">
                            <Row>
                                <Col>
                                    <div className="date-icon">
                                        <EqIconCalendar
                                            eqWidth={34}
                                            eqHeight={34}
                                            eqClass="eq-cal-icon"
                                            eqFill="#083b49"
                                        />
                                        <div className="day">
                                            {moment(ticksToMilliSeconds(item.date)).format("DD")}
                                        </div>
                                        <div className="month">
                                            {moment(ticksToMilliSeconds(item.date)).format("MMM")}
                                        </div>
                                    </div>
                                </Col>
                                <Col className="header-details">
                                    <Row>
                                        <Col></Col>
                                        <Col>
                                            <span className="time">{item.userName}</span>
                                        </Col>
                                        <Col className="price">
                                            <EtTag>{UnpaidOrdersType[item.orderType]}</EtTag>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="eq-f-th">{item.title}</Col>
                                        <Col className="price" style={{paddingLeft:"4px"}}>
                                      <EqIconPrice
                                          eqWidth="15"
                                          eqHeight="13"
                                          eqFill="#b5b5b5"
                                      />
                                      
                                  </Col>
                                  <Col>{item?.amount}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>

                        <Col className="action-col">
                            <EqButton
                                style={{ marginRight: "10px" }}
                                onClick={() => handleShowMessageModal(item.userEmail)}
                            >
                                {t("SendAMessage")}
                            </EqButton>

                            <EqButton onClick={() => showReminderModal(item.userEmail)}>
                                {t("sendReminder")}
                            </EqButton>
                        </Col>
                    </Row>
                </div>
            ))}
        </Modal>
    );
};

export default UnpaidOrdersModalTrainer;
